var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fa5d00;fill-rule:evenodd;}.c{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H150V150H0V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.72,90.81v45.28h-7.62V68.03c0-4.2,3.43-7.49,7.62-7.49h22.55v22.64c0,4.2-3.29,7.65-7.47,7.65h-15.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.5,14.95h7.47v113.49c0,4.2-3.43,7.65-7.47,7.65h-7.62V52.73c0-4.2,3.43-7.5,7.62-7.5V14.95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.86,136.09V22.45c0-4.2,3.43-7.5,7.62-7.5h7.47v113.49c0,4.2-3.29,7.65-7.47,7.65h-7.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.95,136.09h-7.47V22.6c0-4.2,3.43-7.65,7.47-7.65h7.62V98.31c0,4.2-3.43,7.5-7.62,7.5v30.28Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.58,136.09V22.45c0-4.2,3.43-7.5,7.62-7.5h7.47v113.49c0,4.2-3.29,7.65-7.47,7.65h-7.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarvest);
export default __webpack_public_path__ + "static/media/harvest.3ebfb08a93706c104f5db0852daad88f.svg";
export { ForwardRef as ReactComponent };